<script lang="ts">
  import ClassStudentListTable from '$lib/components/classes/ClassStudentListTable.svelte';
  import Loading from '$lib/components/Loading.svelte';
  import type { PageProps } from './$types';

  let { params, data }: PageProps = $props();
  let classId = $derived(parseInt(params.id));
  const all = Promise.all([data.coursePromise, data.clinicalGroupsPromise]);
</script>

{#await all}
  <Loading />
{:then [course, clinicalGroups]}
  <ClassStudentListTable {classId} {course} {clinicalGroups} />
{/await}
